// Polygon's websocket symbol format — ONE definition.
//
// Client, Mantis "Forex data": "There is an issue with our forex data… if you go
// to this pairing on any time frame and you let the chart sit for 30 seconds to
// a minute, the bar is going to jump either up green or down red. But the price
// isn't moving… Maybe forex isn't using WebSockets. Not sure, but forex is
// different from stocks, and i believe crypto. I tested those two and do not see
// the bar jump."
//
// They were right. Polygon's REST tickers and its WEBSOCKET channel names are
// not the same string for pairs: REST wants C:EURUSD / X:BTCUSD, the socket
// wants C:EUR-USD / X:BTC-USD. Six places in this app built that subscription,
// every one of them hyphenated CRYPTO and none of them hyphenated FOREX — so
// every forex subscription in the product was addressed to a channel that does
// not exist.
//
// And Polygon does not complain. Measured against the live feed with our own
// key, subscribing to all of them at once for 30 seconds:
//
//     FMV.C:EURUSD    -> "status: success, subscribed to: FMV.C:EURUSD",  0 messages
//     FMV.C:EUR-USD   -> subscribed,                                     28 messages
//     C.C:EUR-USD     -> subscribed,                                    100 messages
//
// A silent, accepted, permanently empty subscription. That is why this survived:
// there was no error anywhere to find. Forex simply never received a live price,
// on the chart, in the order ticket, or in the buy/sell sheet.
//
// So the rule lives here, once, and every subscriber calls it. Getting these two
// out of step across six files is exactly what produced the bug.

// Which Polygon cluster a ticker belongs to. "X:" crypto, "C:" forex, else stocks.
export const polygonCluster = (ticker) => {
  const s = String(ticker || "");
  if (s.startsWith("X:")) return "crypto";
  if (s.startsWith("C:")) return "forex";
  return "stocks";
};

/**
 * The symbol as the WEBSOCKET addresses it.
 *
 *   "AAPL"       -> "AAPL"        (stocks are the same either way)
 *   "X:BTCUSD"   -> "X:BTC-USD"
 *   "C:EURUSD"   -> "C:EUR-USD"   <- this is the line that was missing
 *
 * Already-hyphenated input is returned unchanged, so calling this twice is safe.
 */
export const polygonWsSymbol = (ticker) => {
  const s = String(ticker || "");
  const prefix = s.slice(0, 2);
  if (prefix !== "X:" && prefix !== "C:") return s;

  const pair = s.slice(2);
  if (pair.includes("-")) return s; // already in websocket form
  // Both classes are quoted as two 3-letter currencies. Anything else (a longer
  // crypto base, say) is left alone rather than sliced into something wrong.
  if (pair.length !== 6) return s;

  return `${prefix}${pair.slice(0, 3)}-${pair.slice(3)}`;
};

export default polygonWsSymbol;
